import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { LiveLabAnalysis, LiveLabSession } from '@/types/livelab';

interface LiveLabStore {
  sessions: LiveLabSession[];
  addSession: (s: LiveLabSession) => void;
  removeSession: (id: string) => void;
  attachAnalysis: (id: string, analysis: LiveLabAnalysis) => void;
  clearAll: () => void;
}

export const useLiveLabStore = create<LiveLabStore>()(
  persist(
    (set) => ({
      sessions: [],
      addSession: (s) => set((state) => ({ sessions: [s, ...state.sessions] })),
      removeSession: (id) =>
        set((state) => ({
          sessions: state.sessions.filter((x) => x.id !== id),
        })),
      attachAnalysis: (id, analysis) =>
        set((state) => ({
          sessions: state.sessions.map((s) => (s.id === id ? { ...s, analysis } : s)),
        })),
      clearAll: () => set({ sessions: [] }),
    }),
    { name: 'sales-academy-livelab-v1' },
  ),
);
